// Форматирование чисел легенды: краёв цветовой шкалы слоя. Точность выбираем от
// РАЗМАХА диапазона, а не жёстко — у слоёв он от 0.95 (течения, м/с) до 100
// (индекс, %). Десятичный разделитель — запятая (русский интерфейс, как у
// подписей изотерм/фронтов).

/** Число знаков после запятой по размаху шкалы. */
export function legendDecimals(span: number): number {
  const s = Math.abs(span)
  if (s >= 50) return 0 // кислород 150–350, индекс 0–100
  if (s >= 3) return 1 // sst ~8–25, ветер 0–20, солёность
  return 2 // течения 0–0.95, аномалия уровня ±0.5
}

/** Значение края шкалы → строка с запятой; −0 нормализуем в 0. */
export function formatLegendValue(value: number, span: number): string {
  const d = legendDecimals(span)
  const v = Object.is(value, -0) ? 0 : value
  return v.toFixed(d).replace('.', ',')
}
